<app-navigation class="coded-navbar pc-sidebar" [ngClass]="{
    'navbar-collapsed': navCollapsed,
    horizontal: currentLayout === 'horizontal',
    compact: currentLayout === 'compact',
    'mob-open': navCollapsedMob
  }" (NavCollapsedMob)="closeMenu()" />
<app-nav-bar (NavCollapse)="this.navCollapsed = !this.navCollapsed" (NavCollapsedMob)="navMobClick()" />
<div class="pc-container">
  <div class="coded-wrapper">
    <div class="coded-content">
      <div class="coded-inner-content">
        <app-breadcrumb />
        <div class="main-body">
          <div class="page-wrapper">
            <router-outlet />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="pc-menu-overlay" (click)="closeMenu()" (keydown)="handleKeyDown($event)" tabindex="0"></div>
</div>
<footer class="pc-footer">
  <div class="footer-wrapper container-fluid">
    <div class="row">
      <div class="col my-1">
        <p class="m-0">
          Copyright &copy;
          <a href="https://avery.com/" target="_blank">ImpresoDev Team</a>
        </p>
      </div>
      <!-- <div class="col-auto my-1">
        <ul class="list-inline footer-link mb-0">
          <li class="list-inline-item"><a href="https://github.com/codedthemes/berry-free-angular-admin-template/"
              target="_blank">Github</a></li>
          <li class="list-inline-item">
            <a href="https://www.figma.com/community/file/1468460364009262125/berry-free-dashboard-ui-kit"
              target="_blank">Figma UI Kit</a>
          </li>
        </ul>
      </div> -->
    </div>
  </div>
</footer>
<!-- <app-configuration /> -->